<template>
  <div class="history">
    <div class="top">
      <div class="back" @click="back" >
        <i class="el-icon-arrow-left" /> 返回
      </div>
      <div class="path">
        <i class="el-icon-location" /> 首页-待办日常-历史会议
      </div>
    </div>

    <div class="historycont">
      <div class="timeselect">时间筛选：
        <el-date-picker
          v-model="time"
          size="small"
          type="date"
          @change="timechange"
          placeholder="选择日期">
        </el-date-picker>
      </div>
      <div class="wire" />
      <div class="meetingcont">
        <div class="meetingbox" @click="particulars = true" v-for="item in conferencelisdata" :key="item.gid">
          <div class="meetingImg" />
          <div class="meetingRight">
            <div class="meetingHeadline">{{item.title}}</div>
            <div class="meetingtext">发布人：<span>{{item.username}}</span></div>
            <div class="meetingtext">会议时间：<span>{{item.starttime}}</span></div>
            <div class="meetingtext">会议地点：<span>{{item.address}}</span></div>
          </div>
          <div class="meetingTip">已结束</div>
        </div>
        <div style="clear:both" />
        <el-pagination
          class="pagin"
          @current-change="pagechange"
          background
          layout="prev, pager, next"
          :total="total"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { APIMAP } from "@/constants/apiConstants";
import { getServerData } from "@/utils/fetchData";
import { getFormatDate } from "@/utils/util";
export default {
  data() {
    return {
      time: "",
      conferencelisdata: [],
      total: 0,
      page: 1
    };
  },
  computed: {
    ...mapState(["userInfo"])
  },
  mounted() {
    this.conferencelist();
  },
  methods: {
    back() {
      this.$router.push({ name: "everyday" });
    },
    pagechange(e) {
      this.page = e;
      this.conferencelist();
    },
    timechange(e) {
      console.log(e);
      if (e) {
        this.time = getFormatDate(e).substring(0, 10);
      } else {
        this.time = "";
      }
      this.page = 1;
      this.conferencelist();
    },
    async conferencelist() {
      // const endtime = getFormatDate().substring(0, 10) + " 00:00:00";
      var param = {
        pid: this.userInfo.platformid,
        size: 15,
        page: this.page
      };
      if (this.time) {
        param.endTime = this.time + " 23:59:59";
        param.startTime = this.time + " 00:00:00";
      }
      console.log(param);
      try {
        const res = await getServerData(APIMAP.MEETING, param, "get");
        console.log("列表", res);
        const data = res.rows;
        this.conferencelisdata = data;
        this.total = res.total / 15 * 10;
      } catch (e) {
        console.log(e);
      }
    }
  }
};
</script>

<style lang="less" scoped>
.history {
  background-color: #f5f6fd;
  padding: 17px 19px;
  height: calc(100vh - 100px);
  width: 100%;
  .top {
    height: 49px;
    background: white;
    font-size: 14px;
    font-family: PingFangSC, PingFangSC-Regular;
    color: #99a9ba;
    overflow: hidden;
    position: relative;
    border-radius: 4px;
    box-shadow: 0px 6px 14px 0px rgba(127, 170, 217, 0.12);
    .back {
      margin-left: 19px;
      margin-top: 15px;
      display: inline-block;
      cursor: pointer;
    }
    .path {
      margin-left: 19px;
      margin-top: 15px;
      display: inline-block;
    }
  }
  .historycont {
    height: calc(100vh - 195px);
    margin-top: 9px;
    background: white;
    font-size: 14px;
    font-family: PingFangSC, PingFangSC-Regular;
    overflow: hidden;
    position: relative;
    border-radius: 4px;
    box-shadow: 0px 6px 14px 0px rgba(127, 170, 217, 0.12);
    padding: 18px 20px;
    .pagin {
      position: absolute;
      right: 7px;
      bottom: 15px;
    }
    .timeselect {
      color: #909ead;
    }
    .wire {
      margin-top: 10px;
      border: 1px solid rgba(226, 229, 236, 0.6);
    }
    .meetingcont {
      border: 1px solid #e2e5ec;
      padding: 15px;
      margin-top: 15px;
      border-radius: 2px;
      position: relative;
      height: calc(100vh - 285px);
      overflow: auto;
      .historybtn {
        font-size: 12px;
        font-family: PingFangSC, PingFangSC-Regular;
        color: #99a9ba;
        position: absolute;
        right: 0px;
        top: -25px;
        cursor: pointer;
      }
      .meetingbox {
        width: calc(33.3% - 30px);
        height: 100px;
        float: left;
        padding: 12px 15px;
        overflow: hidden;
        margin-bottom: 5px;
        position: relative;
        // min-width: 340px;
        .meetingImg {
          width: 100px;
          height: 100px;
          background: #ccc;
          float: left;
          margin-right: 18px;
        }
        .meetingRight {
          float: left;
          color: #969aa5;
          font-size: 14px;
          width: calc(100% - 118px);
          .meetingHeadline {
            font-family: PingFangSC, PingFangSC-Medium;
            font-size: 14px;
            font-weight: 900;
            color: #2c3a50;
            letter-spacing: 2px;
            width: 70%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .meetingtext {
            margin-top: 4px;
            span {
              color: #38455a;
              display: inline-block;
              width: 60%;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              position: relative;
              top: 4px;
            }
          }
        }
        .meetingTip {
          position: absolute;
          top: 15px;
          right: 15px;
          color: #0ac386;
          font-size: 14px;
        }
        .imgtip {
          position: absolute;
          bottom: 15px;
          right: 15px;
          color: #ffb431;
          font-size: 14px;
        }
      }
    }
  }
}
</style>
